import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Video from "./Pages/Video";
import Image from "./Pages/Image";
import Event from "./Pages/Event";

import History from "./Pages/History";
import Team from "./Pages/Team";
import SimilarFestival from "./Pages/SimilarFestival";



function App() {
  return (
    <Router>
      <div className="App">
       
        {/* Page Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/video-gallery" element={<Video />} />
          <Route path="/image-gallery" element={<Image />} />
          <Route path="/Event" element={<Event />} />
          <Route path="/History" element={<History />} />
          <Route path="/Team" element={<Team />} />
          <Route path="/SimilarFestival" element={<SimilarFestival />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
